var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.loading > 0}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"65"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }